<template>
  <div class="h-screen">
    <div class="overflow-hidden overflow-y-scroll pb-98 bg-page">
      <CurrentProject />

      <div class="px-12 bg-white">
        <FormItem label="服务类型" :border="false" :required="true" />

        <!-- 根据后台设置，分为文字型服务类型和图形型服务类型； -->
        <template v-if="faulttypeType.value === 1">
          <FaultTypeList
            :active-id="formData.faulttype.id"
            :list="faultTypePicker.columns"
            @select="item => faultTypeChange(item, 1)"
          />
          <FaultTypeList
            style="margin-top: 8px;"
            :active-id="formData.faulttype.id"
            :list="moreFaultType"
            :cols="1"
            @select="item => faultTypeChange(item, 2)"
          />
          <div class="flex text-center text-theme text-15 leading-40">
            <div class="flex-1" @click="emergencyFaultPicker.show = true">
              紧急故障
            </div>
            <div class="flex-1" @click="faultTypePicker.show = true">
              查看更多
            </div>
          </div>
        </template>

        <div v-if="faulttypeType.value === 2" class="pb-20">
          <van-swipe class="my-swipe" indicator-color="rgba(0,0,0,0.80)">
            <van-swipe-item v-for="(i, index) in choosePicFaultType.columns" :key="index">
              <div class="grid grid-cols-5 gap-15">
                <div
                  v-for="item in i"
                  :key="item.id"
                  @click="changePicFaultType(item, 1)"
                  class="flex flex-col items-center"
                >
                  <div
                    class="relative w-48 h-48 mb-8 border-white-2 rounded-full"
                    :class="formData.faulttype.id === item.id && 'border-all-2-active'"
                  >
                    <van-image
                      width="48"
                      height="48"
                      :round="true"
                      :src="item.icon_url ? item.icon_url : require('../../assets/icons/defaultApproval.png')"
                    />
                    <div
                      class="w-20 h-10 flex items-center absolute bg-theme justify-center rounded-8 bottom-0 right-0"
                      v-if="item.lists && item.lists.length"
                    >
                      <span class="w-3 h-3 bg-white rounded-full mr-2"></span>
                      <span class="w-3 h-3 bg-white rounded-full mr-2"></span>
                      <span class="w-3 h-3 bg-white rounded-full"></span>
                    </div>
                  </div>
                  <div class="text-12 line-clamp-1" :class="formData.faulttype.id === item.id && 'text-theme'">
                    {{ item.faulttype }}
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="text-theme text-15 leading-20 font-500 mt-16 flex" v-if="formData.faulttype.faulttype">
            已选：
            <div class="flex-1">
              {{ formData.faulttype.faulttype_type_name ? `${formData.faulttype.faulttype_type_name} - ` : "" }}
              {{ formData.faulttype.faulttype }}
            </div>
          </div>
        </div>

        <!-- 当通过扫描设备二维码进入该页面时显示该字段，否则不显示 -->
        <PleaseSelect
          v-if="$route.query.deviceId"
          label="关联设备"
          :name="formData.device.deviceName"
          @click="selectDevicePicker.show = true"
        />

        <!-- 如当前用户身份为住宅人员或通过扫描位置二维码进入该页面且位置有关联的住宅号时显示该字段，否则不显示 -->
        <PleaseSelect
          v-if="userInfo.user_type == '8' || $route.query.houseId"
          label="关联住宅号"
          :name="formData.house.house_number"
          @click="selectHousePicker.show = true"
        />

        <!-- 当前用户身份为客户时，显示关联客户字段，自动带入客户机构名称，点击底部弹窗可选择当前用户所属客户机构名称/不关联客户 -->
        <PleaseSelect
          v-if="userInfo.user_type == '3' || $route.query.storesId"
          label="关联客户"
          :name="formData.store.stores_name"
          @click="selectCustomerPicker.show = true"
        />

        <Desc
          v-model="formData.place.true_place_name"
          label="报单位置"
          maxlength="50"
          :required="true"
          @change="formData.place.id = ''"
        />

        <div class="text-center py-16 text-theme text-15">
          <span @click="selectLocationPicker.show = true"> 选择位置 </span>
        </div>

        <Desc v-model="formData.cause" label="报单内容" :required="true" />

        <UploadCom
          label="上传图片"
          :accept="isPowerVideo ? 'image/*,video/*' : 'image/*'"
          @change="list => (formData.fault_pic = list)"
        />

        <PleaseSelect label="预约时间" :name="formData.fault_appointment_time" @click="selectTimePicker.show = true" />
      </div>
    </div>

    <FooterButton ok-text="确认" :show-cancel="false" @submit="onSubmit" />

    <!-- 紧急故障 -->
    <PopupPicker
      v-model:show="emergencyFaultPicker.show"
      title="选择紧急故障"
      hide-search
      :columns="emergencyFaultPicker.columns"
      :columns-field-names="{
        text: 'faulttype',
        value: 'id',
        children: 'lists'
      }"
      @confirm="emergencyFaultPicker.onConfirm"
    />

    <!-- 查看更多 -->
    <SelectFaultType v-model:show="faultTypePicker.show" @confirm="faultTypePicker.onConfirm" />

    <!-- 重复报单提示 -->
    <RepeatFault
      v-model:show="repeatFaultDialog.show"
      :data="repeatFaultDialog.data"
      @confirm="repeatFaultDialog.onConfirm"
    />

    <!-- 是否关联设备 -->
    <van-popup v-model:show="selectDevicePicker.show" position="bottom">
      <van-picker
        :columns="selectDevicePicker.columns"
        @confirm="selectDevicePicker.onConfirm"
        @cancel="selectDevicePicker.show = false"
      />
    </van-popup>

    <!-- 是否关联客户 -->
    <van-popup v-model:show="selectCustomerPicker.show" position="bottom">
      <van-picker
        :columns="selectCustomerPicker.columns"
        @confirm="selectCustomerPicker.onConfirm"
        @cancel="selectCustomerPicker.show = false"
      />
    </van-popup>

    <!-- 是否关联住宅号 -->
    <van-popup v-model:show="selectHousePicker.show" position="bottom">
      <van-picker
        :columns="selectHousePicker.columns"
        :columns-field-names="{ text: 'house_number', value: 'house_id' }"
        @confirm="selectHousePicker.onConfirm"
        @cancel="selectHousePicker.show = false"
      />
    </van-popup>

    <!-- 选择位置 -->
    <SelectLocation v-model:show="selectLocationPicker.show" @confirm="selectLocationPicker.onConfirm" />

    <!-- 预约时间 -->
    <van-popup v-model:show="selectTimePicker.show" position="bottom" @open="selectTimePicker.open">
      <van-datetime-picker
        v-model="selectTimePicker.date"
        type="datetime"
        title="预约日期"
        :min-date="selectTimePicker.minDate"
        :max-date="selectTimePicker.maxDate"
        @confirm="selectTimePicker.onConfirm"
        @cancel="selectTimePicker.onCancel"
      />
    </van-popup>

    <!-- 图形选择 -->
    <Popup v-model:show="choosePicFaultType.picPopUp" title="请选择二级服务类型" height="60%" :round="true">
      <div class="flex flex-col h-full px-12 overflow-y-scroll">
        <div class="py-15 pb-98">
          <div
            v-for="item in formData.faulttype.lists"
            :key="item.id"
            @click="choosePicFaultType.change(item)"
            class="text-14 leading-20 py-10 px-20 rounded-8 mb-10 flex justify-between"
            :class="
              choosePicFaultType.faulttype.id === item.id
                ? 'border-all-active bg-theme2 text-theme'
                : 'border-all2 bg-gray2 text-default'
            "
          >
            <div class="flex-1">{{ item.faulttype }}</div>
            <van-radio v-show="choosePicFaultType.faulttype.id === item.id" icon-size="20px" />
          </div>
        </div>

        <FooterButton
          okText="确认"
          @cancel="choosePicFaultType.picPopUp = false"
          @submit="choosePicFaultType.confirm"
        />
      </div>
    </Popup>
  </div>
</template>
<script setup>
import to from "await-to-js";
import { ref, reactive, computed, onMounted } from "vue";
import { repairService, alarmService } from "@/service";
import { Toast } from "vant";
import Popup from "@/components/PopupPicker/Popup.vue";
import PopupPicker from "@/components/PopupPicker/Picker.vue";
import FaultTypeList from "./components/add/FaultTypeList.vue";
import SelectFaultType from "./components/add/SelectFaultType.vue";
import SelectLocation from "./components/add/SelectLocation.vue";
import RepeatFault from "./components/add/RepeatFault.vue";
import dayjs from "dayjs";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/store";
import { vLoading } from "@/utils/loading";
import { Desc, PleaseSelect, UploadCom, FooterButton, FormItem, CurrentProject } from "@/components/FormView/index";

const store = useStore();
const userInfo = computed(() => store.state.userInfo);
const isPowerVideo = computed(() => userInfo.value.power.includes("151"));

const route = useRoute();
const router = useRouter();

const faulttypeType = reactive({
  value: 1, // 1文字型 2图形型
  getConfig: async () => {
    try {
      const { data } = await repairService.repair_config_detail();
      faulttypeType.value = Number(data.data.faulttype_type) || 1;
    } catch {
      // error
    }
  }
});

const storesInfo = computed(() => {
  if (route.query?.storesId) {
    return { id: route.query.storesId, stores_name: route.query?.storesName };
  }
  return userInfo.value?.stores_id && Number(userInfo.value?.stores_id)
    ? { id: userInfo.value?.stores_id, stores_name: userInfo.value?.stores_name }
    : { id: "", stores_name: "" };
});

const deviceInfo = computed(() => {
  return route.query?.deviceId
    ? { id: route.query?.deviceId, deviceName: route.query?.deviceName }
    : { id: "", deviceName: "" };
});

const houseInfo = computed(() => {
  return userInfo.value?.user_type == "8" ? userInfo.value?.user_house_arr : [];
});

const placeInfo = computed(() => {
  if (route.query.placeId) {
    return {
      id: route.query.placeId,
      true_place_name: route.query.placeName
    };
  } else {
    if (route.query?.placeName) {
      return { id: "", true_place_name: route.query.placeName };
    } else {
      const list = userInfo.value.stores_place_lists;
      return list && list.length
        ? { id: list[0].id, true_place_name: list[0].true_place_name }
        : { id: "", true_place_name: "" };
    }
  }
});

const spaceName = computed(() => route.query?.spaceName || "");

const formData = reactive({
  faulttype: { id: "" },
  store: { ...storesInfo.value },
  place: { ...placeInfo.value },
  device: { ...deviceInfo.value },
  cause: spaceName.value,
  fault_pic: [],
  fault_appointment_time: "",
  house: { ...houseInfo.value[0] }
});

// 更多类型
const moreFaultType = ref([]);
const faultTypeChange = (item, type) => {
  if (type === 1) moreFaultType.value = [];
  formData.faulttype = item;
};

// 图形类型
const choosePicFaultType = reactive({
  picPopUp: false,
  columns: [],
  faulttype: {},
  change(item) {
    choosePicFaultType.faulttype = item;
  },
  confirm() {
    choosePicFaultType.picPopUp = false;
    formData.faulttype = choosePicFaultType.faulttype;
  }
});
const changePicFaultType = item => {
  formData.faulttype = item;

  if (item.lists.length) {
    choosePicFaultType.picPopUp = true;
  }
};

// 普通类型
const faultTypePicker = reactive({
  show: false,
  columns: [],
  picCol: [],
  onConfirm(selectedValue) {
    const isHas = faultTypePicker.columns.find(i => i.id === selectedValue.id);
    formData.faulttype = selectedValue;
    if (!isHas) moreFaultType.value = [selectedValue];
  }
});

// 紧急类型
const emergencyFaultPicker = reactive({
  show: false,
  columns: [],
  onConfirm(selectedValue) {
    if (!selectedValue.length) return Toast.fail("请选择紧急故障类型");
    emergencyFaultPicker.show = false;
    formData.faulttype = selectedValue[0];
    moreFaultType.value = selectedValue;
  }
});

const selectCustomerPicker = reactive({
  show: false,
  columns: [
    { text: storesInfo.value.stores_name, value: storesInfo.value.id },
    { text: "不关联客户", value: "" }
  ],
  onConfirm(selectedOptions) {
    selectCustomerPicker.show = false;
    formData.store.id = selectedOptions.value;
    formData.store.stores_name = selectedOptions.text;
  }
});

const selectLocationPicker = reactive({
  show: false,
  onConfirm(selectedValue) {
    formData.place = selectedValue;
  }
});

const selectDevicePicker = reactive({
  show: false,
  columns: [
    { text: deviceInfo.value.deviceName, value: deviceInfo.value.id },
    { text: "不关联设备", value: "" }
  ],
  onConfirm(selectedOptions) {
    console.log(selectedOptions);
    selectDevicePicker.show = false;
    formData.device.id = selectedOptions.value;
    formData.device.deviceName = selectedOptions.text;
  }
});

const selectHousePicker = reactive({
  show: false,
  columns: [...houseInfo.value, { house_number: "不关联住宅", house_id: "" }],
  onConfirm(selectedOptions) {
    selectHousePicker.show = false;
    formData.house = { ...selectedOptions };
  }
});

// 预约时间
const selectTimePicker = reactive({
  show: false,
  date: new Date(),
  minDate: new Date(),
  maxDate: new Date(),
  open() {
    selectTimePicker.minDate = dayjs()
      .add("5", "minutes")
      .toDate();
    selectTimePicker.maxDate = dayjs()
      .add("1", "months")
      .toDate();
  },
  onCancel() {
    selectTimePicker.show = false;
  },
  onConfirm() {
    formData.fault_appointment_time = dayjs(selectTimePicker.date).format("YYYY-MM-DD HH:mm");
    selectTimePicker.show = false;
  }
});

// 重复报单的提示
const repeatFaultDialog = reactive({
  show: false,
  data: {},
  onConfirm() {
    onSubmit(false);
  }
});
// 最后的提交
const onSubmit = async (checkRepeat = true) => {
  if (!formData.faulttype.id) return Toast.fail("服务类型不能为空");
  if (!formData.place.true_place_name) return Toast.fail("报单位置不能为空");
  if (!formData.cause) return Toast.fail("报单内容不能为空");
  if (formData.fault_pic.some(file => file.status === "uploading")) return Toast.fail("有图片未上传完成");

  vLoading.start();

  const { fault_appointment_time } = formData;
  const time = fault_appointment_time && dayjs(fault_appointment_time).unix();

  const body = {
    ads_txt: formData.place.id ? "" : formData.place.true_place_name,
    fault_pic: formData.fault_pic.map(item => item.id).join(),
    cause: formData.cause,
    faulttype_id: formData.faulttype.id,
    stores_id: formData.store.id,
    is_wjy_relation: formData.store.id ? "1" : "2",
    place_id: formData.place.id,
    fault_appointment_time: time,
    check_repeat: checkRepeat ? "1" : "0",
    device_ids: formData.device.id
  };

  try {
    const [error, data] = await to(repairService.addFault(body));
    if (error) {
      if (error.returncode === "006") {
        repeatFaultDialog.data = error.data;
        repeatFaultDialog.show = true;
      }
      return;
    }
    router.replace({
      name: "repairDetail",
      query: {
        id: data.data.finishId
      }
    });
  } catch (error) {
    console.log(error);
  } finally {
    vLoading.stop();
  }
};

const getSearchFaultType = async () => {
  const { data } = await repairService.searchFaultType({ urgent_state: "2" });
  emergencyFaultPicker.columns = data.data;
};

const getFaultType = async () => {
  choosePicFaultType.columns = [];
  const { data } = await repairService.getFaultType({ pagesize: 99999, more: "1" });
  faultTypePicker.columns = data.data;

  for (let i = 0; i < data.data.length; i += 10) {
    choosePicFaultType.columns.push(data.data.slice(i, i + 10));
  }
};

const getAlarmDetail = async () => {
  const id = route.query.id;
  if (!id) return;
  const [err, { data }] = await to(alarmService.alarm_detail({ id }));
  if (err) return;
  if (data.place_id && data.place_id != "0") {
    formData.place = {
      id: data.place_id,
      true_place_name: data.true_place_name
    };

    if (data.device_id && data.device_id != "0") {
      formData.device = {
        id: data.device_id,
        name: data.device_name
      };
    }
  }

  if (data.alarm_content) formData.cause = data.alarm_content;
};

onMounted(() => {
  getSearchFaultType();
  getFaultType();
  getAlarmDetail();
  faulttypeType.getConfig();
});
</script>

<style scoped lang="less">
:deep(.van-swipe__indicators) {
  position: initial;
  transform: none;
  margin-top: 16px;
  display: flex;
  justify-content: center;

  .van-swipe__indicator {
    width: 5px;
    height: 5px;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 5px;
  }
  .van-swipe__indicator--active {
    width: 15px;
    background-color: rgba(0, 0, 0, 0.8);
  }
}
</style>
